import React from 'react';
// Import Helmet for managing the document head
import { Helmet } from 'react-helmet-async'; // Assuming you use react-helmet-async

import PracticQuestionSubjects from '../subjects/PracticQuestionSubjects';

function PracticeQuestions() {

  

  return (

    <>
     
      <PracticQuestionSubjects 
        name="NCERT-Based Questions (DPP)" 
        link="practice-question-topics" 
        type="dpp" 
      />

    </>
  );
}

export default PracticeQuestions;